import { useEffect } from "react";

export const useAutoResizeIframe = () => {
  useEffect(() => {
    const rootElement = document.getElementById("root");
    let lastSentHeight = 0;

    const sendHeight = () => {
      const newHeight = rootElement ? rootElement.scrollHeight : document.body.scrollHeight;
      // Only send if height is meaningful and actually changed
      if (newHeight > 0 && newHeight !== lastSentHeight) {
        lastSentHeight = newHeight;
        window.parent.postMessage({ type: "content_height", height: newHeight }, "*");
      }
    };

    const debouncedSendHeight = debounce(sendHeight, 100);

    const observer = new ResizeObserver(debouncedSendHeight);
    observer.observe(rootElement ?? document.body);

    // Delay initial height send to let content settle
    const initialTimer = setTimeout(sendHeight, 50);

    return () => {
      observer.disconnect();
      clearTimeout(initialTimer);
    };
  }, []);
};

function debounce<T extends (...args: any[]) => void>(func: T, delay: number): T {
  let timeoutId: ReturnType<typeof setTimeout>;
  return function (...args: any[]) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func(...args), delay);
  } as T;
}
